import { render, staticRenderFns } from "./VTasks.vue?vue&type=template&id=1a04800a&"
import script from "./VTasks.vue?vue&type=script&lang=js&"
export * from "./VTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports